import '../vendor/TimedPopup.js';

$(function () {
  const $newsletterPopUp = $('#newsletter-popup');
  if($newsletterPopUp.length <= 0) return false;

  window.dAgency.showNewsletterPopUp = () => {
    $newsletterPopUp.addClass('timed-popup__visible');
  }

  window.dAgency.hideNewsletterPopUp = () => {
    $newsletterPopUp.removeClass('timed-popup__visible');
  }

  const $newsletterFooter = $('.site-footer .footer__main-content__newsletter__button');
  if($newsletterFooter.length > 0) {
    $newsletterFooter.on('click', function () {
      window.dAgency.showNewsletterPopUp();
    });
  }

  const $newsletterBanner = $('.newsletter-banner__container .newsletter-banner__button');
  if($newsletterBanner.length > 0) {
    $newsletterBanner.on('click', function () {
      window.dAgency.showNewsletterPopUp();
    });
  }

  const $newsletterOpenerButton = $('.newsletter-popup-opener');
  if($newsletterOpenerButton.length > 0) {
    $newsletterOpenerButton.on('click', function () {
      window.dAgency.showNewsletterPopUp();
    });
  }
});
